import React, { Component } from 'react'

class PolysSVG extends Component {
  constructor(props) {
    super(props)
    this.state = { poly: null, allPoints: [], color: null }
  }

  getRandomColor() {
    return `rgba(20, 32, 50, ${Math.random()})`
  }

  generateCells() {
    let cells = []
    let allPoints = this.state.allPoints ? this.state.allPoints : []
    const size = 10
    const number = 100

    let pos = `0,0 20,0 20,20 0,20`
    for (let i = 0; i < 8; i++) {
      for (let j = 0; j < 32; j++) {
        const color = this.getRandomColor()

        let p1 = `${i * size + Math.random() * 11.5},${j * size +
          Math.random() * 11.5}`
        const p1Key = `${i * 1},${j * 1}`

        if (allPoints.some(x => x[p1Key])) {
          p1 = allPoints.find(x => x[p1Key])[p1Key]
        } else {
          allPoints.push({ [p1Key]: p1 })
        }

        let p2 = `${i * size + size + Math.random() * 11.5},${j * size +
          Math.random() * 11.5}`
        const p2Key = `${i * 1 + 1},${j * 1}`

        if (allPoints.some(x => x[p2Key])) {
          p2 = allPoints.find(x => x[p2Key])[p2Key]
        } else {
          allPoints.push({ [p2Key]: p2 })
        }

        let p3 = `${i * size + size + Math.random() * 11.5},${j * size +
          size +
          Math.random() * 11.5}`
        const p3Key = `${i * 1 + 1},${j * 1 + 1}`

        if (allPoints.some(x => x[p3Key])) {
          p3 = allPoints.find(x => x[p3Key])[p3Key]
        } else {
          allPoints.push({ [p3Key]: p3 })
        }

        let p4 = `${i * size + Math.random() * 11.5},${j * size +
          size +
          Math.random() * 11.5}`
        const p4Key = `${i * 1},${j * 1 + 1}`

        if (allPoints.some(x => x[p4Key])) {
          p4 = allPoints.find(x => x[p4Key])[p4Key]
        } else {
          allPoints.push({ [p4Key]: p4 })
        }

        pos = `${p1} ${p2} ${p3} ${p4}`
        cells.push(
          <polygon key={`${i},${j}`} points={pos} fill={color} stroke="none" />
        )
      }
    }
    this.setState(() => ({ allPoints }))
    return cells
  }

  render() {
    return (
      <svg viewBox="10 10 80 160" xmlns="http://www.w3.org/2000/svg">
        {this.generateCells()}
      </svg>
    )
  }
}

export default PolysSVG
